export const environment = {
  URL: 'https://spriced.cdbu.reports.simadvisory.com',
  KEYCLOAK_URL: 'https://auth.simadvisory.com/auth',
  KEYCLOAK_REALM: 'PROD_SPRICED_NRP',
  KEYCLOAK_CLIENT_ID: 'PROD_SPRICED_CDBU_Client',
  const_url_report: 'https://spriced.cdbu.reports.simadvisory.com/',
  const_url_process: 'https://spriced.cdbu.reports.simadvisory.com/',
};
